import { Container } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './component/Header';
import React from 'react'
import Footer from './component/Footer';
import { Outlet } from 'react-router-dom';

//import Chatbot from './front-components/Chatbot.jsx';

/*function App() {
  return <Chatbot />;
}

export default App;

*/

const App = () => {

  const appStyle = {
    backgroundColor: '#F5F5F5', // Replace with your desired color
  };

  return (
    <>
    <Header />
    <main className='py-3' style={appStyle}>
      <Container>
        <Outlet />
      </Container>
    </main>
    <Footer />
    <ToastContainer />
     </>
  )
}

export default App
